import * as React from 'react';

interface ServiceSectionHeaderProps {
	title: string;
	subtitle: string;
}

export const ServiceSectionHeader: React.FC<ServiceSectionHeaderProps> = ({
	title,
	subtitle,
}) => {
	return (
		<header className='md:px-6'>
			<h2 className='text-4xl font-bold leading-none text-neutral-800 max-md:text-4xl'>
				{title}
			</h2>
			<p className='mt-2 text-xl leading-snug text-neutral-800 text-center'>
				{subtitle}
			</p>
			<span className='block w-20 h-1 mt-2 rounded-sm bg-[#FBB040] mx-auto'></span>
		</header>
	);
};
